import {findIndex} from 'lodash';

const defaultState = {
  items: [],
  sessions: [],
  item: {},
  slide: null,
  loaded: false,
  loaded_imgs: true,
}


const slider = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_SLIDER':
      return {...state, item: action.data, loaded: action.items.filter(_i => _i.type == 'image').length == 0, items: action.items}
    case 'SET_SLIDER_LOADED':
      return {...state, loaded: action.data};
    case 'SET_SLIDER_LOADED_IMGS':
      return {...state, loaded_imgs: action.data};  
    case 'GET_SLIDER_SESSIONS':
      return {...state, sessions: action.data};
    case 'SET_SLIDER_ORDERS':
      return {...state, items: state.items.map(item => {
        let index = findIndex(action.data, ['id', item.id]);
        if(index > -1){
          item.order_x = action.data[index].order_x;
        }
        return {...item};
      })}
    case 'SET_SLIDER_SLIDE':
      return {...state, slide: action.data} 
    case 'ADD_SLIDER_ITEM':
      return {...state, items: [...state.items, {...action.data, order_x: isNaN(parseInt(action.data.order_x)) ? action.data.order_x : parseInt(action.data.order_x)}]} 
    case 'DELETE_SLIDER_ITEM':
      return {...state, slide: null, items: [...state.items.filter(item => item.id != action.data)]}
    case 'DELETE_SLIDER_ITEMS':
      return {...state, slide: null, items: [...state.items.filter(item => !action.data.includes(item.id) )]}
    case 'CLEAR_SLIDER':
      return defaultState 
    default:
      return state;
  }
}

export default slider;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/slider.js